@if (rendering && viewModel$ | async; as vm) {
  @if (vm.isVisible) {
    <wl-rich-text-wrapper
      [field]="
        rendering?.fields?.ProductOverviewTitle
          | interpolate
            : {
                mode: 'rich_text',
                variables: {
                  savings:
                    vm.selectedProductsTotalYearlySavings
                    | currency: 'EUR' : 'symbol' : '1.0-0',
                },
              }
      "
    >
      <p class="mb-1"></p>
    </wl-rich-text-wrapper>
    <div class="row mb-6">
      <div class="col-12">
        @if (vm.addressData) {
          <p wlCSMask>
            Bekijk met welke soorten isolatie jij jaarlijks kan besparen op
            <strong>
              {{ vm.addressData.street }}
              {{ vm.addressData.housenumber }},
              {{ vm.addressData.postalcode }}
              {{ vm.addressData.city }}
            </strong>
          </p>
        }
      </div>
    </div>
    <div [id]="insulationProductOverviewKey" class="pb-4">
      <wl-generic-offer-container
        [products]="vm.products"
        [listName]="rendering.componentName"
      >
        <ng-template let-implicitProduct let-context="context">
          @if (stronglyTypedProduct(implicitProduct); as product) {
            <div class="h-100">
              <wl-generic-offer
                [rendering]="rendering"
                [wlTrackProduct]="{
                  track: product,
                  trackingConfig: trackProductConfig,
                  context: context,
                  trackMode: 'product-impression',
                }"
                [product]="product"
                [selected]="productSelected(vm.selectedProducts, product)"
                mode="select"
                class="d-flex h-100"
              >
                <wl-generic-price-info
                  top
                  class="d-block mx-2"
                  [prefixLabel]="rendering.fields.ProductPricePrefixLabel"
                  [suffixLabel]="rendering.fields.ProductPriceSuffixLabel"
                  [price]="product.yearlySavings"
                  [hasContentBelow]="!product.content.productInfo?.length"
                ></wl-generic-price-info>
                <div bottom class="p-2">
                  <wl-toggle-with-info
                    [rendering]="rendering"
                    [title]="rendering.fields.ToggleProductTitle"
                    [description]="rendering.fields.ToggleProductDescription"
                    toggleId="insulation-product-toggle-{{ context.index }}"
                    [checked]="productSelected(vm.selectedProducts, product)"
                    (toggle)="toggleProduct(product)"
                  >
                  </wl-toggle-with-info>
                </div>
              </wl-generic-offer>
            </div>
          }
        </ng-template>
      </wl-generic-offer-container>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-4">
        <button
          [disabled]="vm.selectedProducts.length === 0"
          type="submit"
          class="btn btn-sales-primary w-100"
          (click)="submitClicked($event, vm.selectedProducts)"
          *scText="rendering.fields.NextPageButtonText"
          wlAutomationId="next-page-button"
        ></button>
      </div>
    </div>
    @if (rendering.fields.SecondaryButton.value?.href) {
      <div class="row justify-content-center mt-1">
        <div class="col-6 col-md-4">
          <a
            type="submit"
            class="btn btn-link w-100"
            *wlGenericLink="rendering.fields.SecondaryButton"
            wlAutomationId="secondary-button"
          ></a>
        </div>
      </div>
    }
  }
}
